<template>
    <v-dialog v-model="dialog" persistent max-width="90%">
        <v-card v-if="rack">
            <v-card-title>
                <span class="text-h5">{{ rack.id ? "Modifica" : "Nuovo" }} Armadio</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="align-center">
                        <v-col v-if="rack.image">
                            <v-card>
                                <v-img
                                    :src="rack.image"
                                    max-height="250"
                                    aspect-ratio="1"
                                    class="grey darken-4"
                                ></v-img>
                                <v-card-title class="justify-end">
                                    <v-btn
                                        color="error"
                                        small
                                        @click="deleteImage"
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-card-title>
                            </v-card>
                        </v-col>
                        <v-col v-else>
                            <v-file-input
                                accept="image/*"
                                label="Foto"
                                prepend-icon="mdi-camera"
                                v-model="file"
                            ></v-file-input>
                        </v-col>
                        <v-col>
                            <v-text-field
                                type="text"
                                label="Descrizione"
                                v-model="rack.description"
                            ></v-text-field>
                        </v-col>

                        <v-col>
                            <v-text-field
                                type="number"
                                label="Dim. (cm)"
                                v-model="rack.size"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <ChipsCombobox
                                :data="rackTypes"
                                label="Tipo"
                                item-value="id"
                                item-text="name"
                                v-model:selectedData="rack.rack_type"
                                @newType="createNewRackType"
                                @change="onChange('rack_type', $event)"
                            ></ChipsCombobox>
                        </v-col>

                        <v-col>
                            <ChipsCombobox
                                :data="fmailies"
                                label="Famiglie"
                                item-value="acl_codcla1"
                                item-text="acl_descla1"
                                chips
                                multiple
                                v-model:selectedData="rack.families"
                                @change="onChange('families', $event)"
                            ></ChipsCombobox>
                        </v-col>
                        <v-col>
                            <ChipsCombobox
                                :data="shops"
                                label="Negozi"
                                item-value="id"
                                item-text="description"
                                chips
                                multiple
                                v-model:selectedData="rack.shops"
                                @change="onChange('shops', $event)"
                            ></ChipsCombobox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeDialog">Close</v-btn>
                <v-btn color="primary" text @click="save()">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import requests from "../../../requests";
import ChipsCombobox from "../components/ChipsCombobox.vue";
export default {
    name: "CreateModalComponent",

    props: {
        dialog: Boolean,
    },

    components: {
        ChipsCombobox,
    },

    model: {
        prop: ["dialog"],
        event: ["update:dialog"],
    },

    mounted() {
        this.getShopList();
        this.getRackTypes();
        this.getFamilies();
    },

    data() {
        return {
            shops: [],
            rackTypes: [],
            fmailies: [],
            file: null,
            rack: null,
        };
    },

    methods: {
        closeDialog() {
            this.$emit("update:dialog", false);
        },

        getShopList() {
            requests.getShopList().then((res) => {
                this.shops = res.data;
            });
        },

        getFamilies() {
            requests.getFamilies().then((res) => {
                this.fmailies = res.data;
            });
        },

        getRackTypes() {
            requests.getRackTypes().then((res) => {
                this.rackTypes = res.data;
            });
        },
        createNewRackType(name) {
            requests.createRackType(name).then((res) => {
                this.rackTypes.push(res.data);
                this.rack.rack_type_id = res.data.id;
            });
        },
        save() {
            requests.saveRack(this.rack).then((res) => {
                if (!_.isNull(this.file)) {
                    requests
                        .uploadRackFile(this.file, res.data.id)
                        .then((resImg) => {
                            this.$emit("saved", resImg.data);
                            this.closeDialog();
                        });
                } else {
                    this.closeDialog();
                }
            });
        },

        setRackData(rackData) {
            this.rack = rackData;
        },

        onChange(attr, val) {
            this.rack[attr] = val;
            console.log(this.rack);
        },

        deleteImage() {
            if (window.confirm("Cancellare l'immagine?")) {
                requests.deleteRackFile(this.rack.id).then((res) => {
                    this.rack.image = null;
                });
            }
        },
    },
};
</script>
